<template>
    <div class="dropdown multi-select-vue" ref="dropDownElement">
        <button
            :class="`btn btn-light bg-white dropdown-border ps-2  ${disabled ? 'disabled' : ''} ${classes}`"
            type="button"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            :disabled="disabled"
        >
            <span>{{ getbuttonText }}</span>
            <span class="dropdown-toggle ps-2"></span>
        </button>
        <div class="dropdown-menu" ref="dropDownMenu">
            <div class="input-group p-1">
                <input
                    type="text"
                    class="form-control"
                    ref="searchInput"
                    v-model="search"
                    :placeholder="getsearchPlaceholder"
                />
                <div class="input-group-append">
                    <div class="input-group-text">
                        <i class="fas fa-search"></i>
                    </div>
                </div>
            </div>
            <div class="dropdown-item p-0 my-1" v-if="!search">
                <div class="form-check ps-2">
                    <label class="form-check-label ms-2">
                        <input
                            class="form-check-input-sm"
                            type="checkbox"
                            :checked="selectedOptions.length === getdropDownOptionsLength"
                            @change.prevent="toggleAllSelected()"
                        />
                        Select All
                    </label>
                </div>
            </div>
            <div class="dropdown-divider" v-if="!search"></div>
            <div class="content">
                <div v-for="groupName of Object.keys(filteredOptions)" :key="groupName">
                    <button
                        type="button"
                        class="btn btn-link border-0"
                        v-if="groupName && filteredOptions[groupName].length > 0"
                        @click="toggleAllGroupOptions(groupName)"
                    >
                        {{ groupName }}
                    </button>
                    <div
                        class="dropdown-item p-0 my-1"
                        v-for="option in filteredOptions[groupName]"
                        :key="option.value"
                    >
                        <div class="form-check ps-2" :for="`option-${option}`">
                            <label class="form-check-label ms-2">
                                <input
                                    class="form-check-input-sm"
                                    type="checkbox"
                                    :id="`option-${option}`"
                                    @change.prevent="toggleSingleSelection(option.value)"
                                    :checked="selectedOptions.includes(option.value)"
                                    :disabled="option.disabled"
                                />
                                {{ option.displayText }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dropdown-divider"></div>
            <div class="px-1">
                <button type="button" class="btn btn-xs btn-outline-dark w-100" @click="closeDropDown()">Close</button>
            </div>
        </div>
    </div>
</template>

<style src="./MultiSelect.scss"></style>
<script lang="ts" src="./MultiSelect.ts"></script>
